module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_5010.db7ed3d2.png";